import { getIsInFlowsItem } from "../../reducers/session";

import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import iconsShape from "./shapes/iconsShape";
import languageShape from "./shapes/languageShape";
import capitalizeFirstLetter from "./util/capitalizeFirstLetter";
import { IAppState } from "../../types/stores";

import Button from "@material-ui/core/Button";

type Direction = "left" | "right" | "up" | "down";

type Props = {
    direction: Direction;
    disabled: boolean;
    icons: iconsShape;
    id: string;
    lang: languageShape;
    onClick: any;
    isMoveAll: boolean;
};
const Action: React.FC<Props> = ({ direction, disabled, icons, id, lang, onClick, isMoveAll }: Props) => {
    const isInFlowsItem = useSelector((state: IAppState) => getIsInFlowsItem(state));
    /**
     * @returns {void}
     */
    const onClickFunction = () => {
        onClick({
            direction,
            isMoveAll,
        });
    };

    /**
     * @returns {string}
     */
    const getId = () => `${id}-move${isMoveAll ? "-all" : ""}-${direction}`;

    /**
     * @returns {string}
     */
    const getActionKey = () => `move${isMoveAll ? "All" : ""}${capitalizeFirstLetter(direction)}`;

    /**
     * @returns {string}
     */
    const getLabel = () => lang[getActionKey()];

    /**
     * @returns {*}
     */
    const renderIcons = () => icons[getActionKey()];

    const idValue = getId();
    const label = getLabel();
    const className = classNames({
        "rdl-move": true,
        "rdl-move-all": isMoveAll,
        [`rdl-move-${direction}`]: true,
    });

    let action = (
        <button
            aria-label={label}
            className={className}
            disabled={disabled}
            id={idValue}
            title={label}
            type="button"
            onClick={onClickFunction}
        >
            {renderIcons()}
        </button>
    );

    if (isInFlowsItem) {
        action = (
            <Button
                aria-label={label}
                className={className}
                disabled={disabled}
                id={idValue}
                title={label}
                onClick={onClickFunction}
                variant="outlined"
                size="small"
            >
                {renderIcons()}
            </Button>
        );
    }

    return action;
};
export default Action;
